module.exports = __webpack_public_path__ + "img/open_access_photo_groupe.d65d7faf.jpg";